import { createSlice } from '@reduxjs/toolkit';
import { TInspirationGallery } from 'app-entities/inspiration-gallery/inspiration-gallery.type';
import { DEFAULT_PROJECTS_COUNT_PER_REQUEST } from 'app-entities/projects/projects.const';
import { LARGE } from 'app-entities/inspiration-gallery/gallery-view.const';
import { KZ_REGION_ID } from 'common/consts/region-ids.consts';

export type TPropsFromParentMicrofront = {
  inspirationGalleryDataFromModel: TInspirationGallery;
  regionId: string;
  paddings?: boolean;
  analyticsName?: string;
  isCollectionAvailable: boolean;
};

export const initialState: TPropsFromParentMicrofront = {
  inspirationGalleryDataFromModel: {
    title: '',
    secondTitle: '',
    showProjectName: false,
    showProjectMinPrice: false,
    numberOfProjectsInGallery: `${DEFAULT_PROJECTS_COUNT_PER_REQUEST}`,
    galleryView: '',
    inspirationRooms: [],
  },
  regionId: '',
  paddings: true,
  isCollectionAvailable: false
};

export const dataFromParentMicrofrontSlice = createSlice({
  name: 'dataFromParentMicrofront',
  initialState: initialState,
  reducers: {},
  selectors: {
    selectGalleryTitle: state => state.inspirationGalleryDataFromModel.title,
    selectGallerySubtitle: state => state.inspirationGalleryDataFromModel.secondTitle,
    selectIsLargeView: state => state.inspirationGalleryDataFromModel.galleryView.toUpperCase() === LARGE,
    selectIsKZRegion: state => state.regionId === KZ_REGION_ID,
    selectIsPaddingsEnabled: state => state.paddings,
    selectAnalyticsName: state => state.analyticsName,
    selectIsCollectionAvailable: state => state.isCollectionAvailable,
    selectIsShowProjectName: state => state.inspirationGalleryDataFromModel.showProjectName,
    selectProjectsRoomType: state => state.inspirationGalleryDataFromModel.inspirationRooms?.[0]?.roomType ?? null,
  },
});
